export const tangoLogo = "/images/logo/Tango_Logo_with_tagline.png";
export const defaultImage = "/broken-image.jpg";
export const defaultFemaleImage = "/images/avatar/av_female.png";
export const defaultMaleImage = "/images/avatar/av_male.png";